import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Tooltip from "@material-ui/core/Tooltip";
import editIcons from "../../../assets/images/edit-icon.png";
import searchIcons from "../../../assets/images/search-icon.png";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import LoadingButton from "../../../components/LoadingButton";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import BuyerOrgHeader from "../../BuyerOrgHeader";
import {
  getRealtorList,
  handleUserStatus
} from "../../../actions/organisation";
import { openSnackBar } from "../../../actions/snack-bar";
import AddRealtorModal from "../../../components/Organisation/AddRealtorModal";
import { CircularProgress } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

class OrgDashboard extends React.Component {
  state = {
    realtorList: [],
    pageSize: 10,
    pageNumber: 1,
    keyword: "",
    count: 0,
    loading: false,
    openBar: false,
    isAdmin: false,
    showingListPath: ''
  };
  handleMenu = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ pageNumber: newPage + 1 }, () => {
      this.getList();
    });
  };

  componentDidMount() {
    const isAdmin = this.props.match.path === '/admin/manage-realtor';
    const showingListPath = isAdmin ? '/admin/showings-list/' : '/organization/showings-list/';
    this.setState({ isAdmin, showingListPath }, () => { this.getList(); });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.refreshList && !this.props.refreshList) {
      this.getList();
    }
  }

  getList = () => {
    this.setState({ loading: true });
    const { pageNumber, pageSize, keyword, isAdmin } = this.state;
    this.props
      .dispatch(getRealtorList(pageNumber, pageSize, keyword, isAdmin))
      .then(response => {
        this.setState({
          realtorList: response.data,
          count: response.count,
          loading: false
        });
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  setKeyword = event => {
    this.setState({ keyword: event.target.value });
  };

  addRealtor = realtorData => {
    const data = realtorData && JSON.parse(JSON.stringify(realtorData));
    if (data && data.phone) {
      data.phone = data.phone.replace('+1', '');
    }
    this.props.dispatch({
      type: "ADD_REALTOR",
      payload: true,
      data: data,
      isUpdated: false
    });
  };

  searchKeyword = (event, getList = false) => {
    if (event.key === "Enter" || getList) {
      this.setState(
        {
          pageSize: 10,
          pageNumber: 1
        },
        () => {
          this.getList();
        }
      );
    }
  };

  handleUser = (event, realtorId, status) => {
    this.setState({ loading: true });
    status = status === "active" ? "deactive" : "active";
    event.preventDefault();
    this.props
      .dispatch(handleUserStatus(realtorId, status))
      .then(response => {
        this.closeOpenBar();
        this.getList();
        this.props.dispatch(
          openSnackBar({
            message: response.message
          })
        );
      })
      .catch(err => {
        this.setState({ loading: false });
        const message = err && err.message;
        this.props.dispatch(
          openSnackBar({
            message
          })
        );
      });
  };

  setOpenBar = (realtorId, status) => {
    if (status) {
      this.closeOpenBar();
      return;
    }
    this.closeOpenBar()
    const { realtorList } = this.state;
    const foundIndex = realtorList.findIndex(x => x.id === realtorId);
    realtorList[foundIndex].openBar = true;
    this.setState({ realtorList });
  }

  closeOpenBar = () => {
    this.state.realtorList.map(r => { r.openBar = false });
  }

  render() {
    const { classes, editRealtorData } = this.props;

    return (
      <div>
        <BuyerOrgHeader authentication={this.props.authentication} />
        <div className={classes.container}>
          <div className={classes.pageLoader}>
            {this.state.loading && <CircularProgress size={60} />}
          </div>
          <div className={classes.innerWrap}>
            <div className={classes.headingWrap}>
              <Typography variant="h2" className={classes.headingWrapheading}>
                {this.state.isAdmin ? 'MANAGE REALTOR ' : 'DASHBOARD'}
                {this.state.isAdmin && !this.state.loading && `(${this.state.count})`}
              </Typography>

              <div className={classes.headingButtonWrap}>
                {!this.state.isAdmin && <LoadingButton
                  variant="contained"
                  className={classes.largeButton}
                  onClick={() => this.addRealtor()}
                >
                  Add Realtor
                </LoadingButton>}

                <Paper className={classes.searchInput}>
                  <InputBase
                    className={classes.input}
                    placeholder="Search Realtor"
                    inputProps={{ "aria-label": "Search Realtor" }}
                    onChange={this.setKeyword}
                    onKeyPress={this.searchKeyword}
                  />
                  <IconButton
                    onClick={e => this.searchKeyword(e, true)}
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    <img src={searchIcons} alt="Search Icon" />
                  </IconButton>
                </Paper>
              </div>
            </div>
            <div className={classes.dashboardTable}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Realtor ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Mobile No. </TableCell>
                    <TableCell>Email Id</TableCell>
                    <TableCell className={classes.tableCenter}>No. of Showings </TableCell>
                    {this.state.isAdmin && <TableCell>Organization</TableCell>}
                    <TableCell>Account Status</TableCell>
                    <TableCell className={classes.tableCenter}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.realtorList.map(realtor => {
                    return (
                      <TableRow key={realtor.id}>
                        <TableCell component="th">{realtor.id}</TableCell>
                        <TableCell>
                          {realtor.first_name + " " + realtor.last_name}{" "}
                        </TableCell>
                        <TableCell>{realtor.phone}</TableCell>
                        <TableCell>{realtor.email}</TableCell>
                        <TableCell

                          className={classes.showingTile}
                        >
                          <Typography>
                            <Tooltip
                              title="View Showings"
                              placement="top-start"
                              className={classes.tg}
                            >
                              <Link
                                to={{
                                  pathname: `${this.state.showingListPath}${realtor.id}`,
                                  state: {
                                    realtorName:
                                      realtor.first_name +
                                      " " +
                                      realtor.last_name
                                  }
                                }}
                              >
                                {realtor.showings_count}
                              </Link>
                            </Tooltip>
                          </Typography>
                        </TableCell>
                        {this.state.isAdmin && <TableCell>{realtor.org_name}</TableCell>}
                        <TableCell>
                          <div className={classes.accountStatusDropdown}>
                            {realtor.status === 'active' ? <span className={classes.textSuccess}>Active</span> :
                              <span className={classes.textDanger}>Deactive</span>}
                            <IconButton
                              aria-label="account of current user"
                              aria-controls="menu-appbar"
                              aria-haspopup="true"
                              onClick={this.handleMenu}
                              color="inherit"
                            >
                              <ExpandMoreIcon onClick={() => this.setOpenBar(realtor.id, realtor.openBar)} />
                            </IconButton>
                            {realtor.openBar && <div className={classes.StatusDropdown}>
                              {realtor.status === 'deactive' ? <Link to="#"
                                onClick={e =>
                                  this.handleUser(e, realtor.id, realtor.status)
                                }
                                className={classes.textSuccess}>
                                Active
                              </Link> :

                                <Link to="#"
                                  onClick={e =>
                                    this.handleUser(e, realtor.id, realtor.status)
                                  }
                                  className={classes.textDanger}>
                                  Deactive
                              </Link>}
                            </div>}
                          </div>
                        </TableCell>
                        <TableCell className={classes.actionTile}>
                          <Typography>
                            <Link
                              to="#"
                              onClick={() => this.addRealtor(realtor)}
                            >
                              <img src={editIcons} alt="Edit Icon" />
                            </Link>
                            {/* <Link
                              to="#"
                              onClick={e =>
                                this.handleUser(e, realtor.id, realtor.status)
                              }
                            >
                              <img src={deleteIcons} alt="delete Icon" />
                            </Link> */}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              {!this.state.loading && !this.state.realtorList.length &&
                <Typography variant="h2" className={classes.noResultFound}>
                  No Result Found
              </Typography>}
            </div>

            {!this.state.loading && <TablePagination
              className={classes.paginationSection}
              component="div"
              count={this.state.count}
              rowsPerPageOptions={[]}
              rowsPerPage={10}
              page={this.state.pageNumber - 1}
              onChangePage={this.handleChangePage}
              backIconButtonProps={{
                "aria-label": "previous page"
              }}
              nextIconButtonProps={{
                "aria-label": "next page"
              }}
            />}
          </div>
          <div className={classes.copyright}>
            @2019 SafeShowings. All Right <span>Resevered</span>
          </div>
        </div>
        {this.props.addRealtorModal && (
          <AddRealtorModal
            open={this.props.addRealtorModal}
            editRealtorData={editRealtorData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updatingUser: state.users.updatingUser,
    addRealtorModal: state.modalHandler.addRealtorModal,
    editRealtorData: state.modalHandler.editRealtorData,
    refreshList: state.modalHandler.refreshList
  };
};
const mapActionsToProps = dispatch => {
  return {
    dispatch
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapActionsToProps
  ),
  withStyles(styles)
)(OrgDashboard);
